<template>
  <div class="invoice-title-page">
    <div class="page-head">
      <div>
        <h2>发票抬头</h2>
        <p>维护常用个人或企业抬头，申请会员会费发票时可直接选择。</p>
      </div>
      <el-button type="primary" @click="openForm()">新增抬头</el-button>
    </div>

    <el-tabs v-model="titleType" @tab-change="loadList">
      <el-tab-pane label="个人抬头" :name="1" />
      <el-tab-pane label="企业抬头" :name="2" />
    </el-tabs>

    <el-table v-loading="loading" :data="rows" border>
      <el-table-column prop="invoice_title" label="发票抬头" min-width="180" show-overflow-tooltip />
      <el-table-column v-if="Number(titleType) === 2" prop="tax_no" label="纳税人识别号" min-width="180" show-overflow-tooltip />
      <el-table-column prop="contact_name" label="收票联系人" width="120" />
      <el-table-column prop="contact_phone" label="收票手机号" width="130" />
      <el-table-column prop="contact_email" label="收票邮箱" min-width="160" show-overflow-tooltip>
        <template #default="scope">{{ scope.row.contact_email || '-' }}</template>
      </el-table-column>
      <el-table-column prop="is_default" label="默认" width="90">
        <template #default="scope">
          <el-tag v-if="scope.row.is_default === 1" type="success">默认</el-tag>
          <span v-else class="muted">-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210" fixed="right">
        <template #default="scope">
          <el-button v-if="scope.row.is_default !== 1" type="primary" link @click="setDefault(scope.row)">设默认</el-button>
          <el-button type="primary" link @click="openForm(scope.row)">编辑</el-button>
          <el-button type="danger" link @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-empty v-if="!loading && rows.length === 0" description="暂无发票抬头" />

    <el-dialog v-model="formVisible" :title="form.id ? '编辑发票抬头' : '新增发票抬头'" width="720px" append-to-body :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="抬头类型" prop="title_type">
          <el-radio-group v-model="form.title_type">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票抬头" prop="invoice_title">
          <el-input v-model="form.invoice_title" placeholder="个人姓名或企业名称" />
        </el-form-item>
        <template v-if="Number(form.title_type) === 2">
          <el-form-item label="纳税人识别号" prop="tax_no">
            <el-input v-model="form.tax_no" placeholder="统一社会信用代码/税号" />
          </el-form-item>
          <el-form-item label="企业地址">
            <el-input v-model="form.company_address" placeholder="选填" />
          </el-form-item>
          <el-form-item label="企业电话">
            <el-input v-model="form.company_phone" placeholder="选填" />
          </el-form-item>
          <el-form-item label="开户银行">
            <el-input v-model="form.bank_name" placeholder="选填" />
          </el-form-item>
          <el-form-item label="银行账号">
            <el-input v-model="form.bank_account" placeholder="选填" />
          </el-form-item>
        </template>
        <el-form-item label="收票联系人" prop="contact_name">
          <el-input v-model="form.contact_name" />
        </el-form-item>
        <el-form-item label="收票手机号" prop="contact_phone">
          <el-input v-model="form.contact_phone" maxlength="11" />
        </el-form-item>
        <el-form-item label="收票邮箱" prop="contact_email">
          <el-input v-model="form.contact_email" placeholder="请输入收票邮箱" />
        </el-form-item>
        <el-form-item label="默认抬头">
          <el-switch v-model="form.is_default" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitForm">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import invoice from '@/api/invoice'

export default {
  name: 'InvoiceTitle',
  data() {
    return {
      titleType: 1,
      loading: false,
      submitting: false,
      rows: [],
      formVisible: false,
      form: this.defaultForm(),
      rules: {
        title_type: [{ required: true, message: '请选择抬头类型', trigger: 'change' }],
        invoice_title: [{ required: true, message: '请填写发票抬头', trigger: 'blur' }],
        tax_no: [{ required: true, message: '请填写纳税人识别号', trigger: 'blur' }],
        contact_name: [{ required: true, message: '请填写收票联系人', trigger: 'blur' }],
        contact_phone: [
          { required: true, message: '请填写收票手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请填写正确的手机号', trigger: 'blur' }
        ],
        contact_email: [
          { required: true, message: '请填写收票邮箱', trigger: 'blur' },
          { type: 'email', message: '请填写正确的邮箱', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    defaultForm() {
      return {
        id: 0,
        title_type: this.titleType || 1,
        invoice_title: '',
        tax_no: '',
        company_address: '',
        company_phone: '',
        bank_name: '',
        bank_account: '',
        contact_name: '',
        contact_phone: '',
        contact_email: '',
        is_default: 0
      }
    },
    async loadList() {
      // 常用抬头按个人/企业分组维护，默认抬头会排在列表前面。
      this.loading = true
      try {
        const res = await invoice.titleList({ title_type: this.titleType })
        this.rows = res && res.data ? res.data : []
      } finally {
        this.loading = false
      }
    },
    openForm(row) {
      this.form = row ? { ...this.defaultForm(), ...row } : this.defaultForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    submitForm() {
      // 保存的是可复用抬头资料；真正申请发票时仍会复制一份快照到申请表。
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const res = await invoice.saveTitle(this.form)
          if (res) {
            this.$message.success(res.msg || '保存成功')
            this.formVisible = false
            this.titleType = this.form.title_type
            await this.loadList()
          }
        } finally {
          this.submitting = false
        }
      })
    },
    async setDefault(row) {
      // 默认抬头按类型互斥：个人和企业可以各有一个默认值。
      const res = await invoice.setDefaultTitle({ id: row.id })
      if (res) {
        this.$message.success(res.msg || '设置成功')
        await this.loadList()
      }
    },
    deleteRow(row) {
      this.$confirm('确认删除该发票抬头？', '提示', { type: 'warning' })
        .then(async () => {
          const res = await invoice.deleteTitle({ id: row.id })
          if (res) {
            this.$message.success(res.msg || '删除成功')
            await this.loadList()
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.invoice-title-page {
  padding: 24px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.page-head h2 {
  margin: 0 0 8px;
  font-size: 22px;
  color: #303133;
}

.page-head p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

.muted {
  color: #909399;
}

@media (max-width: 768px) {
  .invoice-title-page {
    padding: 16px;
  }

  .page-head {
    flex-direction: column;
  }
}
</style>
